import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Grow from '@material-ui/core/Grow'
import Fade from '@material-ui/core/Fade'
import Collapse from '@material-ui/core/Collapse'

export const Hider = (props) => {
  const hiderRef = useRef(null)

  if (props.scrollIntoView) {
    useEffect(() => handleShow(props, hiderRef), [props.show])
  }

  if (props.withTransition) {
    const TransitionElement = selectTransitionElement(props)
    return (
      <TransitionElement mountOnEnter unmountOnExit
        className={`${props.className || ''} full-width`} in={props.show}>
        <div>
          {props.render()}
        </div>
      </TransitionElement>
    )
  } else {
    return (
      <div ref={hiderRef}>
        {props.show && props.render()}
      </div>
    )
  }
}

const handleShow = (props, hiderRef) => {
  if (props.show && hiderRef && props.scrollIntoView) {
    hiderRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

const selectTransitionElement = ({ grow, fade, collapse }) => {
  let transitionElement = Fade
  if (grow) {
    transitionElement = Grow
  } else if (collapse) {
    transitionElement = Collapse
  }
  return transitionElement
}

export const HiderPropTypes = {
  show: PropTypes.bool.isRequired,
  className: PropTypes.string,
  withTransition: PropTypes.bool,
  grow: PropTypes.bool,
  fade: PropTypes.bool,
  collapse: PropTypes.bool,
  render: PropTypes.func.isRequired,
  scrollIntoView: PropTypes.bool
}

Hider.propTypes = {
  ...HiderPropTypes
}
